<div class="editprofile" style="padding: 10px;">
    <h2 mat-dialog-title>Edit Profile</h2>
    <mat-dialog-content>
        <mat-form-field appearance="outline">
            <mat-label>First Name</mat-label>
            <input [attr.guide]="'editprofile-inp-1' + '__' + sanitizedUrl" matInput [(ngModel)]="data.firstName"/>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Last Name</mat-label>
            <input [attr.guide]="'editprofile-inp-2' + '__' + sanitizedUrl" matInput [(ngModel)]="data.lastName"/>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Job Title</mat-label>
            <input [attr.guide]="'editprofile-inp-3' + '__' + sanitizedUrl" matInput [(ngModel)]="data.jobTitle"/>
        </mat-form-field>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button [attr.guide]="'editprofile-btn-4' + '__' + sanitizedUrl" mat-button (click)="onCancel()">Cancel</button>
        <button [attr.guide]="'editprofile-btn-5' + '__' + sanitizedUrl" mat-flat-button color="primary" (click)="onSave()">Save</button>
    </mat-dialog-actions>
</div>
